import React, { useEffect, useState } from 'react';
import SpecialDeal from './SpecialDeal';
import { Banner } from '@v2/shared/lib/types';

export default function SpecialDeals() {
  const [banners, setBanners] = useState<Banner[]>([]);

  useEffect(() => {
    let cancelled = false;

    fetch('/services_api/storefront/v1/banners.json?tags[0]=HOMEPAGE_SPECIAL_DEALS')
      .then((response) => (response.ok ? response.json() : { results: [] }))
      .then((data) => {
        if (!cancelled) {
          setBanners(data.results || []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBanners([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (banners.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 xl:grid-cols-3 gap-y-5 lg:gap-8 mb-8 lg:mb-14">
      {banners.map((banner) => (
        <SpecialDeal key={banner.id} banner={banner} />
      ))}
    </div>
  );
}
